
export const MenuItem = ({ item, defaultExpanded }: MenuItemProps) => {
    const hasChildren = item.children && item.children.length > 0;
    const { onClick, actionLabel } = item;

    if (!hasChildren) {
        return (
            <li key={item.id}>
                {onClick ? (
                    // A real button: in the tab order and activatable from the
                    // keyboard, unlike an href-less anchor.
                    <button type="button" onClick={onClick}>
                        {item.label}
                    </button>
                ) : (
                    <a>{item.label}</a>
                )}
            </li>
        );
    }

    // A node with children spends its row on expand/collapse, so its onClick
    // gets an explicit action button. It is a sibling of <details>, never a
    // child of <summary>: the summary is itself a control, and interactive
    // content nested in it folds into the summary's accessible name.
    return (
        <li key={item.id}>
            <details open={defaultExpanded}>
                <summary>{item.label}</summary>
                <ul>
                    {item.children!.map((child) => (
                        <MenuItem
                            key={child.id}
                            item={child}
                            defaultExpanded={defaultExpanded}
                        />
                    ))}
                </ul>
            </details>
            {onClick && actionLabel && (
                <button
                    type="button"
                    className="btn btn-ghost btn-xs text-neutral self-start"
                    aria-label={`${actionLabel} ${item.label}`}
                    onClick={onClick}
                >
                    {actionLabel}
                </button>
            )}
        </li>
    );
};

export interface MenuItemProps {
    item: MenuItemType;
    defaultExpanded: boolean;
}

export interface MenuItemType {
    id: string | number;
    label: string;
    children?: MenuItemType[];
    onClick?: () => void;
    // Text of the row action button that fires onClick on a node WITH
    // children (a leaf fires onClick from its own button and ignores this).
    actionLabel?: string;
}
